import * as React from "react";

import { Dialog, DialogActions, DialogContent, DialogTitle, Text } from "..";

export const OfflineDialog = (props: { isOpen: boolean }) => {
    const { isOpen = false } = props;

    const handleOnClick = () => {
        window.location.reload();
    };

    if (isOpen === false) return null;

    return (
        <Dialog open={isOpen}>
            <DialogTitle title="attention" />
            <DialogContent>
                <Text>
                    Looks like you may be inactive, or we are having
                    difficulties connecting with our services. Please use the
                    refresh button below.
                </Text>
            </DialogContent>
            <DialogActions
                submit={{
                    label: "refresh",
                    onSubmit: handleOnClick,
                }}
            />
        </Dialog>
    );
};
